import {
  getSubscriptionUrl as commonsGetSubscriptionUrl,
  getAuthRedirectUrl as commonsGetAuthRedirectUrl,
  getApiAuthOptions as commonsGetApiAuthOptions,
  getEnvironment,
} from '@demo-system/commons/service/environment'

const API_V1 = process.env.REACT_APP_API_V1
const API_V2 = process.env.REACT_APP_API_V2
const API_PROJECTS = process.env.REACT_APP_API_PROJECTS
const ACCESS_TOKEN = process.env.REACT_APP_DEV_TOKEN

const imsClientIds = {
  test: process.env.REACT_APP_IMS_TEST_CLIENT,
  stage: process.env.REACT_APP_IMS_STAGE_CLIENT,
  prod: process.env.REACT_APP_IMS_PROD_CLIENT,
}

const imsRedirectUris = {
  test: process.env.REACT_APP_IMS_TEST_REDIRECT_URI,
  stage: process.env.REACT_APP_IMS_STAGE_REDIRECT_URI,
  prod: process.env.REACT_APP_IMS_PROD_REDIRECT_URI,
}

const subscriptionEndpoints = {
  localhost: process.env.REACT_APP_DEV_SUBSCRIPTION_URL,
  test: process.env.REACT_APP_TEST_SUBSCRIPTION_URL,
  stage: process.env.REACT_APP_STAGE_SUBSCRIPTION_URL,
  prod: process.env.REACT_APP_PROD_SUBSCRIPTION_URL,
}

const nitrogenUrls = {
  localhost: 'http://localhost:3001',
  test: 'https://dsn-test.adobe.com',
  stage: 'https://dsn-stage.adobe.com',
  prod: 'https://dsn.adobe.com',
}

const homeUrls = {
  localhost: 'http://localhost:3000',
  test: 'https://dsn-test.adobe.com',
  stage: 'https://dsn-stage.adobe.com',
  prod: 'https://dsn.adobe.com',
}

// public per-env livedemos base URLs, selected at runtime by hostname
const livedemosUrls = {
  localhost: 'https://dev.livedemos.adobe.com',
  test: 'https://dev.livedemos.adobe.com',
  stage: 'https://stage.livedemos.adobe.com',
  prod: 'https://livedemos.adobe.com',
}

const getLivedemosWorkspacesUrl = () => livedemosUrls[getEnvironment()] || livedemosUrls.prod

const getLivedemosWorkspaceDetailsUrl = (workspaceId) => {
  if (!workspaceId) return null
  return `${getLivedemosWorkspacesUrl()}/workspaces/${workspaceId}`
}

const getAuthRedirectUrl = () =>
  commonsGetAuthRedirectUrl({
    imsClientIds,
    imsRedirectUris,
    imsInstance: process.env.REACT_APP_IMS_INSTANCE,
  })

const getSubscriptionUrl = () => commonsGetSubscriptionUrl(subscriptionEndpoints)

const getApiAuthOptions = () => commonsGetApiAuthOptions(ACCESS_TOKEN)

const getNitrogenUrl = () => {
  const environment = getEnvironment()
  return nitrogenUrls[environment] || nitrogenUrls.prod
}

const getHomeUrl = () => {
  const environment = getEnvironment()
  return homeUrls[environment] || homeUrls.prod
}

export {
  API_V1,
  API_V2,
  API_PROJECTS,
  ACCESS_TOKEN,
  getApiAuthOptions,
  getAuthRedirectUrl,
  getNitrogenUrl,
  getHomeUrl,
  getSubscriptionUrl,
  getLivedemosWorkspacesUrl,
  getLivedemosWorkspaceDetailsUrl,
}
